export enum COLLEGE_FILTER_FORM_CONTROL {
    SEARCH_KEY = 'SEARCH_KEY',
    COUNTRY = 'ONESHOT_COUNTRY',
    STATE = 'ONESHOT_STATE',
    CITY = 'ONESHOT_CITY',
    COURCE = 'COURCE'
}
